function maskBankNumber(bank) {
  if (!bank) return null;

  const { length } = bank;

  // This takes first 4 numbers of the bank string that will not be masked
  const firstPart = bank.substring(0, 4);

  // This takes first part of the bank string and does a look up
  // to match only the ones between the first and last four digits
  const secondPart = bank.substring(4, length - 4).replace(/\d/g, '*');

  // This takes last 4 numbers of the bank string that will not be masked
  const thirdPart = bank.substring(length - 4);

  return firstPart + secondPart + thirdPart;
}

function maskPhoneNumber(phone) {
  if (!phone) return null;

  const numberLength = phone.length;
  // This takes first half of the phone string and will
  // match only the ones after the first two digits
  const firstHalf = phone.substring(3, numberLength / 2).replace(/\d/g, '*');

  // This takes first half of the phone string and does a look up
  // to match only the ones preceding the last four digits
  const secondHalf = phone.substring(numberLength / 2).replace(/\d(?=\d{4})/g, '*');
  return phone.substring(0, 3) + firstHalf + secondHalf;
}

export {
  maskBankNumber,
  maskPhoneNumber
};
